import React from 'react'
import { MdOutlineAccessTimeFilled } from 'react-icons/md'
import { FaStar, FaCalendarAlt } from 'react-icons/fa'
import { FaRotateLeft } from "react-icons/fa6"
import { HiViewGrid } from 'react-icons/hi'
type Props = {
  value: number
  title: string
  statName: string
  iconColor: string
}

const StatAndTitle = ({ title, value, statName, iconColor }: Props) => {
  const getIcon = () => {
    switch (statName) {
      case 'time':
        return <MdOutlineAccessTimeFilled color={iconColor} />
      case 'themes':
        return <HiViewGrid color={iconColor} />
      case 'skills':
        return <FaStar color={iconColor} />
      case 'enrolled_at':
        return <FaCalendarAlt color={iconColor} />
      case 'subscription':
        return <FaRotateLeft color={iconColor} />
      default:
        break
    }
  }
  return (
    <div className='statAndTitle'>
      <div className='line1'>
        <div className='col1'>{getIcon()}</div>
        <div style={{ color: iconColor === '#fff' ? '#f9f9f9' : '#474747' }} className='col2'>
          {value}
        </div>
      </div>
      <div style={{ color: iconColor === '#fff' ? ' #F9F9F9' : '#9696BD' }} className='line2'>
        {title}
      </div>
    </div>
  )
}

export default StatAndTitle
